import React, { FC, useState } from 'react';
import Modal, { Prompt } from '@ingka/modal';
import Button from '@ingka/button';
import Text from '@ingka/text';
import { Divider, Stack } from '@mui/material';
import useTranslation from '../../hooks/useTranslation';
import { AddMsTeamsLinkPromptProps } from './AddMsTeamsLinkPromptProps';

const AddMsTeamsLinkPrompt: FC<AddMsTeamsLinkPromptProps> = ({
  isVisible,
  passedLink,
  onClose,
  onCancel,
  onAccept,
}) => {
  const t = useTranslation();
  const [link, setLink] = useState(passedLink || '');

  return (
    <Modal
      handleCloseBtn={onClose}
      visible={isVisible}
      data-testid={'add-ms-teams-link-modal'}
      style={{ borderRadius: 16 }}
    >
      <Prompt
        header={null}
        titleId={'add-ms-teams-link-modal-title'}
        aria-label="Accessibility header for a modal"
        className="add-ms-teams-prompt"
        title={
          <Stack mt={4}>
            <span style={{ fontWeight: 700, fontSize: 28 }}>
              {t('common.addMsTeamsLink')}
            </span>
          </Stack>
        }
        footer={<></>}
      >
        <div style={{ marginBottom: 24 }}>
          <span style={{ fontSize: 18 }}>
            {t('common.addMsTeamsLinkDescription')}
          </span>
        </div>
        <div>
          <span
            style={{
              fontWeight: 700,
              fontSize: 18,
              display: 'block',
              marginBottom: 8,
            }}
          >
            Link Existing Channel
          </span>
          <span
            style={{
              fontWeight: 500,
              fontSize: 16,
              display: 'block',
              marginBottom: 8,
            }}
          >
            Microsoft Teams Channel URL
          </span>
          <input
            type="text"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            placeholder={t('common.msTeamsLinkPlaceholder')}
            style={{
              padding: '12px',
              fontSize: '16px',
              width: '100%',
              borderRadius: 8,
              border: '2px solid #ccc',
              marginBottom: 8,
            }}
            data-testid={'ms-teams-link-input'}
          />
          <span style={{ color: '#888', fontSize: 14 }}>
            {t('common.msTeamsLinkLabel')}
          </span>
        </div>
        <Divider sx={{ my: 3 }} />
        <Stack spacing={4} marginBottom={4}>
          <Stack
            direction="row"
            spacing={8}
            justifyContent="space-between"
            alignItems="center"
            sx={{ width: '100%' }}
          >
            <Text style={{ fontWeight: 700, fontSize: 20 }}>
              {t('common.createMsTeams')}
            </Text>
            <Button
              text={t('common.createMsTeams')}
              type="secondary"
              size="small"
              onClick={() => onAccept()}
              data-testid={'add-ms-teams-create-new'}
            />
          </Stack>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
            sx={{ width: '100%' }}
          >
            <Button
              text={t('common.cancel')}
              data-testid={'add-ms-teams-cancel'}
              type="secondary"
              onClick={onCancel}
              style={{
                flex: 1,
              }}
            />
            <Button
              text={t('common.saveLink')}
              data-testid={'add-ms-teams-accept'}
              type="primary"
              onClick={() => onAccept(link)}
              disabled={!link}
              style={{
                flex: 1,
              }}
            />
          </Stack>
        </Stack>
      </Prompt>
    </Modal>
  );
};

export default AddMsTeamsLinkPrompt;
